import { DEV } from "solid-js"
import type { Nullable } from "vite-node"
import entityDisplayName from "../../../core/entity/entityDisplayName"
import { isEntityDesert, isEntityForest, isEntityPlain, isEntityRiver, isEntitySea, isEntityShoal, isEntitySnow } from "../../../core/entity/entityTypeMetaList.generated"
import type { Entity } from "../../../core/entity/index"

export const DEFAULT_SHOAL_TILE_ELEVATION = 0.03
export const DEFAULT_SEA_TILE_ELEVATION = -1
export const DEFAULT_RIVER_TILE_ELEVATION = -0.25
export const DEFAULT_LAND_TILE_ELEVATION = 1

// I use this one for placing prop detail objects on top of the meshes
export default function getTerrainMesh1TileElevationV2(ent: Nullable<Entity>): number {
  if (ent) {
    if (isEntityPlain(ent)) {
      return DEFAULT_LAND_TILE_ELEVATION
    }
    if (isEntityDesert(ent)) {
      return DEFAULT_LAND_TILE_ELEVATION
    }
    if (isEntitySnow(ent)) {
      return DEFAULT_LAND_TILE_ELEVATION
    }
    if (isEntityForest(ent)) {
      return DEFAULT_LAND_TILE_ELEVATION
    }
    if (isEntitySea(ent)) {
      return DEFAULT_SEA_TILE_ELEVATION
    }
    if (isEntityRiver(ent)) {
      return DEFAULT_RIVER_TILE_ELEVATION
    }
    // not the real elevation, but used for ridges
    if (isEntityShoal(ent)) {
      return DEFAULT_SHOAL_TILE_ELEVATION
      // return DEFAULT_SEA_TILE_ELEVATION
    }
    if (DEV) {
      throw new Error(`unknown entity type: ${ent.etype_id} ${entityDisplayName(ent)}`)
    }
    return 3
  }
  return 2
}